"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const constants_1 = require("utils/constants");
const uploadCardWrapper = {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
};
const uploadInnerWrapper = {
    display: 'flex',
    flexDirection: 'column'
};
const uploadZoneWrapper = {
    width: '100%',
    height: 220,
    display: 'flex',
    borderRadius: 10,
    marginBottom: 24,
    alignItems: 'center',
    justifyContent: 'center',
    border: '2px dashed #DEE0E5',
};
const uploadFormTitle = {
    margin: 0,
    fontSize: 16,
    fontWeight: 600,
    marginBottom: 8,
    lineHeight: '24px',
};
const uploadDocWrapper = {
    width: 350,
    height: '100%',
    fontSize: 14,
    display: 'flex',
    cursor: 'pointer',
    textAlign: 'center',
    alignItems: 'center',
    flexDirection: 'column',
    justifyContent: 'center',
};
const uploadText = {
    margin: 0,
    width: 138,
    fontSize: 14,
    marginTop: 15,
    fontWeight: 400,
};
const browseText = {
    color: '#2CBCDD',
    textDecoration: 'underline'
};
const errorText = {
    width: 220,
    color: constants_1.color.redDark,
    margin: 0,
    fontSize: 14,
    marginTop: 12,
    fontWeight: 400,
};
const progressBar = {
    height: 4,
    width: '100%',
    borderRadius: 10,
    backgroundColor: constants_1.color.redDark
};
const uploadResultWrapper = {
    width: '100%',
    display: 'flex',
    borderRadius: 10,
    alignItems: 'flex-start',
    flexDirection: 'column',
    justifyContent: 'center',
};
const documentsInnerWrapper = {
    display: 'flex',
    marginBottom: 10,
    position: 'relative',
    alignItems: 'flex-start',
};
const documentsFilename = {
    display: 'flex',
    marginBottom: 4
};
const filenameWrapper = {
    width: 270,
    marginLeft: 12
};
const filenameText = theme => ({
    margin: 0,
    fontSize: 14,
    maxWidth: 175,
    marginRight: 8,
    fontWeight: 400,
    overflow: 'hidden',
    lineHeight: '24px',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    color: theme === 'dark' ? constants_1.color.white : '#8B8B8B',
});
const filesizeText = theme => ({
    margin: 0,
    fontSize: 14,
    fontWeight: 400,
    lineHeight: '24px',
    color: theme === 'dark' ? constants_1.color.white : '#DEE0E5',
});
const deleteIconWrapper = {
    position: 'absolute',
    top: 0,
    right: 0,
    width: 24,
    height: 24,
    cursor: 'pointer'
};
exports.default = {
    errorText,
    uploadText,
    browseText,
    progressBar,
    filenameText,
    filesizeText,
    uploadFormTitle,
    filenameWrapper,
    uploadDocWrapper,
    uploadCardWrapper,
    uploadZoneWrapper,
    deleteIconWrapper,
    documentsFilename,
    uploadInnerWrapper,
    uploadResultWrapper,
    documentsInnerWrapper,
};
